<script>
	import NoJavaScript from '$components/NoJavaScript.svelte';
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import { fly } from 'svelte/transition';
	import { onMount, tick } from 'svelte';

	const currentYear = new Date().getFullYear();
	let loaded = false;
	onMount(() => {
		loaded = true;
	});
</script>

<div
	class="bg-light-blue min-h-screen h-full bg-auth-bg-img bg-cover bg-center flex justify-center flex-col p-4"
>
	<div class="max-w-xl w-full mx-auto bg-white rounded-2xl p-6 md:p-12">
		{#key loaded && $page.url.pathname}
			<div class="grid gap-4" in:fly={{ y: 20, duration: 800 }}>
				<slot />
			</div>
		{/key}
	</div>

	<div class="mt-8 text-center mx-auto px-6 flex gap-6 items-center text-sm">
		<div class="">© {currentYear} Quantifly</div>
		<div class="border-r h-5 border-dark-gray"></div>
		<div class="hover:underline">{@html $_('auth.layout.terms')}</div>
	</div>
</div>

<NoJavaScript />
